import React, { useEffect } from 'react';
import { FaFileAlt, FaShieldAlt, FaHeart } from 'react-icons/fa';
import PracticeAreaLayout from './PracticeAreaLayout';

const WillsEstatesPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Wills & Estates | Janssen Law Professional Corporation';
  }, []);

  return (
    <PracticeAreaLayout
      title="Wills & Estates"
      subtitle="Thoughtful estate planning and elder law services to protect your family's future."
      heroImage="https://janssen-law.s3.us-east-2.amazonaws.com/wills-estate-law.jpg"
      slug="wills-estates"
      overview={
        <>
          <p>
            Planning for the future is one of the most important steps you can take
            for yourself and your loved ones. At Janssen Law, we provide comprehensive
            estate planning services that address your unique circumstances and ensure
            your wishes are clearly documented and legally enforceable.
          </p>
          <p>
            Charlotte Janssen brings extensive experience in wills, estates, trusts,
            and elder law, working with high net worth clients to develop sophisticated
            estate plans that address both domestic and international considerations.
          </p>
          <p>
            Whether you need a straightforward will, a complex trust arrangement, or
            guidance through the probate process, we approach every matter with the
            same level of care and attention to detail.
          </p>
        </>
      }
      services={[
        'Will Drafting & Review',
        'Estate Planning',
        'Trust Creation & Administration',
        'Powers of Attorney (Property & Personal Care)',
        'Estate Administration',
        'Probate Applications',
        'Elder Law',
        'Succession Planning',
        'Guardianship Applications',
        'Estate Litigation Support',
        'Charitable Giving Strategies',
        'Cross-Border Estate Planning',
      ]}
      whyUsTitle="Why Choose Janssen Law for Wills & Estates?"
      whyUsDescription="Compassionate, thorough estate planning that protects your legacy and provides peace of mind."
      whyUsFeatures={[
        {
          icon: <FaFileAlt />,
          title: 'Comprehensive Planning',
          description:
            'We address all aspects of estate planning, from wills and powers of attorney to trusts and succession strategies.',
        },
        {
          icon: <FaShieldAlt />,
          title: 'Asset Protection',
          description:
            'Strategic planning to protect your assets and minimize tax implications for your beneficiaries.',
        },
        {
          icon: <FaHeart />,
          title: 'Compassionate Approach',
          description:
            'We understand the sensitive nature of estate planning and elder law, providing caring and patient guidance.',
        },
      ]}
    />
  );
};

export default WillsEstatesPage;
